import { CenterSpinnerAtom } from "~/components/Atoms/CenterSpinnerAtom/CenterSpinnerAtom";
import { TabBar } from "~/components/Components/TabBar/TabBar";

type Props = {
  tabBarProps: React.ComponentProps<typeof TabBar>;
};

export const MyPageHistoryModule = (props: Props) => {
  return !props.tabBarProps ? (
    <CenterSpinnerAtom />
  ) : (
    <TabBar {...props.tabBarProps} />
  );
};
